import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Rugs/Rugs_Banner.jpg';
import CircularGallery from './CircularRugsGallery';
import "./Services.css";

function Rugs() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>Rugs</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>India is leading the world today in innovation and product development in handmade rugs. There is a huge variety of constructions, price-points and materials that is available. Each rug is painstakingly created after hundreds of man-hours of effort by skilled artisans. Connect with us to help you develop rug collections that will light-up your market.</p>
                        <p style={{ fontSize: '25px' }} className='text-center text-decoration-underline'><strong>Guinness World Records September 2025.</strong></p>
                        <p style={{ fontSize: '20px' }} className='justify-text'>India amazing work, made the world's largest carpet, registered in the Guinness World Records September 2025.
                            India has entered the Guinness World Record by making the world's largest Custom hand-tufted carpet for the Grand Mosque of Kazakhstan.</p>
                        <p style={{ fontSize: '20px' }} className='justify-text'>This unique custom Hand tufted carpet was manufactured in Bhadohi-India.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>

            {/* <div
                style={{
                    height: 'min(70vh, 600px)',  // up to 700px tall, scales down on small screens
                    minHeight: '400px',          // won’t get too short on mobile
                    position: 'relative',
                }}
            >
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div> */}

        </>
    )
}

export default Rugs